import { SubmissionError } from 'redux-form';
import fetch from '../../utils/fetch';
import { success as createSuccess } from './create';
import { sanitizeDomainName } from './../../utils/helpers';

export function retrieveError(retrieveError) {
  return {type: 'CLIENT_UPDATE_RETRIEVE_ERROR', retrieveError};
}

export function retrieveLoading(retrieveLoading) {
  return {type: 'CLIENT_UPDATE_RETRIEVE_LOADING', retrieveLoading};
}

export function retrieveSuccess(retrieved) {
  return {type: 'CLIENT_UPDATE_RETRIEVE_SUCCESS', retrieved};
}

export function retrieve(id) {
  return (dispatch) => {
    dispatch(retrieveLoading(true));

    return fetch(id)
      .then(response => response.json())
      .then(data => {
        dispatch(retrieveLoading(false));
        dispatch(retrieveSuccess(data));
      })
      .catch(e => {
        dispatch(retrieveLoading(false));
        dispatch(retrieveError(e.message));
      });
  };
}

export function updateError(updateError) {
  return {type: 'CLIENT_UPDATE_UPDATE_ERROR', updateError};
}

export function updateLoading(updateLoading) {
  return {type: 'CLIENT_UPDATE_UPDATE_LOADING', updateLoading};
}

export function updateSuccess(updated) {
  return {type: 'CLIENT_UPDATE_UPDATE_SUCCESS', updated};
}

export function update(item, values, initialCheckedValues) {
  return (dispatch) => {
    dispatch(updateError(null));
    dispatch(createSuccess(null));
    dispatch(updateLoading(true));
    
    //TODO: USER MUST NOT BE SET IN ADMIN SERVER
    if (values.user) {
      delete values.user;
    }

    //NORMALIZE DATA BEFORE PUT REQUEST
    let checkedClientProducts = values.clientProducts.filter(k=>{
      //return only checked values, we only need them
      return (k['name']);
    });
    let normalizedClientProducts = [];

    checkedClientProducts.forEach(k=>{

      let matchedArray = initialCheckedValues.filter( (p,i)=>{
        return k['@id'] === p['product'];
      });

      if(matchedArray.length) {
        normalizedClientProducts.push(matchedArray[0]['@id']);
      }
      else{
        normalizedClientProducts.push({
          'product': k['@id']
        });
      }
    });

    values = {
      ...values,
      clientProducts: normalizedClientProducts,
      domainName: sanitizeDomainName(values.domainName)
    }

    return fetch(item['@id'], {
        method: 'PUT',
        headers: new Headers({'Content-Type': 'application/ld+json'}),
        body: JSON.stringify(values),
      }
    )
      .then(response => response.json())
      .then(data => {
        dispatch(updateLoading(false));
        dispatch(updateSuccess(data));
      })
      .catch(e => {
        dispatch(updateLoading(false));

        if (e instanceof SubmissionError) {
          dispatch(updateError(e.errors._error));
          throw e;
        }

        dispatch(updateError(e.message));
      });
  };
}

export function reset() {
  return {type: 'CLIENT_UPDATE_RESET'};
}



// WEBPACK FOOTER //
// ./src/actions/client/update.js